<template>
  <TransitionRoot as="template" :show="open" class="font-noto">
    <Dialog as="div" class="relative z-999">
      <TransitionChild as="template" enter="ease-out duration-400" enter-from="opacity-0" enter-to="opacity-100"
        leave="ease-in duration-300" leave-from="opacity-100" leave-to="opacity-0">
        <div class="inset-0" />
      </TransitionChild>

      <div class="fixed flex justify-end items-start right-0 top-0 pr-4 pt-4 w-full">
        <div class="shadow-4xl mt-[5%]">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-x-full"
            enter-to="opacity-100 translate-x-0" leave="ease-in duration-200" leave-from="opacity-100 translate-x-0"
            leave-to="opacity-0 -translate-x-full">
            <DialogPanel
              class="w-full shadow border max-w-fit transform px-4 py-2 pr-10 transition-all rounded-md overflow-hidden relative"
              :class="isFailed
                  ? 'border-r-4 border-l-red-600 bg-red-100 text-red-600'
                  : 'border-r-4 border-l-blue-600 bg-gray-100 text-blue-600'
                ">
              <DialogTitle as="h3" class="text-lg font-medium capitalize max-w-[280px] pr-6">
                {{ informMessage ? informMessage : `Updated Successfully!` }}
              </DialogTitle>
              <button
                @click="closeToast"
                class="absolute top-2 right-2 text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-gray-400 rounded"
                :class="isFailed ? 'hover:text-red-800' : 'hover:text-blue-800'"
              >
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";

import { onBeforeUnmount, ref, onMounted } from "@vue/runtime-core";

export default {
  inheritAttrs: false,
  components: {
    Dialog,
    DialogPanel,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
  },
  props: ["informMessage", "isFailed"],
  emits: ["onAutoClose"],
  setup(props, { emit }) {
    const open = ref(true);
    const timerId = ref(null);

    const closeToast = () => {
      if (timerId.value) {
        clearTimeout(timerId.value);
      }
      open.value = false;
      emit("onAutoClose");
    };

    onMounted(() => {
      timerId.value = setTimeout(() => {
        closeToast();
      }, 3000);
    });

    onBeforeUnmount(() => {
      if (timerId.value) {
        clearTimeout(timerId.value);
      }
    });
    return { open, closeToast };
  },
};
</script>
